import axiosInstance from '../services/AxiosInstance';

export function getExecAdmins(page = 1) {
    return axiosInstance.get('exec-admins', { params: { page } });
}

export function createExecAdmin(data) {
    return axiosInstance.post('exec-admins', data);
}

export function updateExecAdmin(userId, data) {
    return axiosInstance.put(`exec-admins/${userId}`, data);
}

export function deactivateExecAdmin(userId) {
    return axiosInstance.patch(`exec-admins/${userId}/deactivate`);
}

export function resendExecAdminVerification(userId) {
    return axiosInstance.post(`exec-admins/${userId}/resend-verification`);
}

export function resendPartnerUserVerification(partnerId, userId) {
    return axiosInstance.post(`partners/${partnerId}/users/${userId}/resend-verification`);
}

export function fixPendingPartnerUserEmail(partnerId, userId, newEmail) {
    return axiosInstance.post(`partners/${partnerId}/users/${userId}/fix-email`, { email: newEmail });
}

export function resendPartnerSuperAdminVerification(partnerId) {
    return axiosInstance.post(`partners/${partnerId}/super-admin/resend-verification`);
}

export function fixPartnerSuperAdminEmail(partnerId, newEmail) {
    return axiosInstance.post(`partners/${partnerId}/super-admin/fix-email`, { email: newEmail });
}

export function getManageableRoles() {
    return axiosInstance.get('manageable-roles');
}

export function getAssignableRoles() {
    return axiosInstance.get('assignable-roles');
}

export function getAllPermissions() {
    return axiosInstance.get('permissions');
}

export function getUsersWhoCanBeAssignedAsReviewers(partnerId) {
    return axiosInstance.get(`partners/${partnerId}/possible-team-reviewers`);
}

export function deletePartnerUser(partnerId, userId) {
  return axiosInstance.delete(`partners/${partnerId}/users/${userId}/delete`);
}

export function getUserWalletBalance(partnerId, userId) {
  return axiosInstance.get(`partners/${partnerId}/users/${userId}/wallet-balance`);
}

export function updatePartnerUser(partnerId, userId, data) {
  return axiosInstance.put(`partners/${partnerId}/users/${userId}/update`, data);
}

export function updateOwnProfile(partnerId, userId, data) {
  return axiosInstance.put(`partners/${partnerId}/users/${userId}/update-profile`, data);
}

export function getSuspendedUsers(partnerId, page = 1, search = '') {
    return axiosInstance.get(`partners/${partnerId}/suspended-users`, {
        params: {
            page,
            ...(search ? { search } : {}),
        },
    });
}

export function setInitialTransactionPin({ partnerId, userId, newPin, newPinConfirmation }) {
  return axiosInstance.post(`partners/${partnerId}/users/${userId}/transaction-pin/initial`, {
    newPin,
    newPin_confirmation: newPinConfirmation,
  });
}

export function changeTransactionPin({ partnerId, userId, currentPin, newPin, newPinConfirmation }) {
  return axiosInstance.put(`partners/${partnerId}/users/${userId}/transaction-pin`, {
    currentPin,
    newPin,
    newPin_confirmation: newPinConfirmation,
  });
}

export function requestTransactionPinReset({ partnerId, userId, password }) {
  return axiosInstance.post(`partners/${partnerId}/users/${userId}/transaction-pin/reset-request`, {
    password,
  });
}

export function confirmTransactionPinReset({ partnerId, userId, otp, newPin, newPinConfirmation }) {
  return axiosInstance.post(`partners/${partnerId}/users/${userId}/transaction-pin/reset-confirm`, {
    otp,
    newPin,
    newPin_confirmation: newPinConfirmation,
  });
}

export function assignUserToTeam(partnerId, userId, teamId) {
  return axiosInstance.put(`partners/${partnerId}/users/${userId}/assign-to-team`, {
    team_id: teamId,
  });
}

export function changeUserRole(partnerId, userId, { roleId, reason, currentPassword }) {
  return axiosInstance.put(`partners/${partnerId}/users/${userId}/change-role`, {
    role_id: roleId,
    reason,
    current_password: currentPassword,
  });
}

export function selfActivateWallet(partnerId, userId, data) {
  return axiosInstance.post(`partners/${partnerId}/users/${userId}/self-activate-wallet`, data);
}

export function activateWallet(partnerId, userId, data) {
  return axiosInstance.post(`partners/${partnerId}/users/${userId}/activate-wallet`, data);
}